<template>
	<div class="content_yf">
		<div class="left_box_yf">
			<div class="table_box_yf" style="width: 100%;">
				<img src="@/assets/imgs/screen/data_box_area1.png" alt="" class="data_box_train0">
				<h3 class="title_yf3">外库作业车次</h3>
				<div ref="chartColumn4" class="flow_data1"></div>
			</div>
			<div class="list_member_box">
				<div class="table_box_yf">
					<img src="@/assets/imgs/screen/data_box_goods.png" alt="" class="list_member">
					<img src="@/assets/imgs/screen/icon_expand.png" alt="" class="icon_expand"
						@click="amplification(1)">
					<h3 class="title_yf1">货类运输统计(吨)</h3>
					<div ref="chartColumn5" class="flow_data2"></div>
				</div>
				<div class="table_box_yf">
					<img src="@/assets/imgs/screen/data_box_goods.png" alt="" class="list_member1">
					<img src="@/assets/imgs/screen/icon_expand.png" alt="" class="icon_expand"
						@click="amplification(2)">
					<h3 class="title_yf1">主要货主排名(吨)</h3>
					<div ref="chartColumn6" class="flow_data3"></div>
				</div>
			</div>
		</div>
		<div class="right_box_yf">
			<div class="table_box_yf" style="width: 100%;">
				<img src="@/assets/imgs/screen/data_box_custom.png" alt="" class="data_box_train1" style="width: 100%;">
				<img src="@/assets/imgs/screen/icon_expand.png" alt="" class="icon_expand" @click="amplification(3)">
				<h3>车队运输统计（车次）</h3>
				<div ref="chartColumn1" class="flow_data"></div>
			</div>
			<div class="table_box_yf " style="width: 100%;">
				<img src="@/assets/imgs/screen/data_box_custom.png" alt="" class="data_box_train1" style="width: 100%;">
				<img src="@/assets/imgs/screen/qiehuan.png" alt="" class="icon_expand" @click="changeYearMonth(1)">
				<h3>{{custom}}{{zykhsgsj_year}}年车辆运输统计（车次）</h3>
				<div ref="chartColumn2" class="flow_data"></div>
			</div>
			<div class="table_box_yf" style="width: 100%;">
				<img src="@/assets/imgs/screen/data_box_train.png" alt="" class="data_box_train2" style="width: 100%;max-height: 340px;">
				<img src="@/assets/imgs/screen/qiehuan.png" alt="" class="icon_expand" @click="changeYearMonth(2)">

				<h3 class="title_yf2">{{custom}}{{hyqydb_year}}年港内集疏对比</h3>
				<div ref="chartColumn3" class="flow_data"></div>
			</div>

		</div>
		<div v-show="amplification1" class="amplification_box">
			<div class="table_box_yf table_box_yf2">
				<img src="@/assets/imgs/screen/data_box_area.png" alt="" class="list_member">
				<img src="@/assets/imgs/screen/icon_close.png" alt="" class="icon_close" @click="un_amplification()">
				<h3 class="title_yf1">货类运输统计</h3>
				<div ref="chartColumn7" class="flow_data_big flow_data_big2"></div>
				<div class="eltable_box_yf">
					<div class="table_title_yf"><span>序号</span><span>货类</span><span>运输量(吨)</span></div>

					<ul>
						<li v-for="(item,index) in cargoname_car_number">
							<span>{{index+1}}</span>
							<span>{{item.name}}</span>
							<span>{{item.value}}</span>
						</li>
					</ul>
				</div>
			</div>

		</div>
		<div v-show="amplification2" class="amplification_box">
			<div class="table_box_yf table_box_yf2">
				<img src="@/assets/imgs/screen/data_box_area.png" alt="" class="list_member">
				<img src="@/assets/imgs/screen/icon_close.png" alt="" class="icon_close" @click="un_amplification()">
				<h3 class="title_yf1">主要货主排名(吨)</h3>
				<div ref="chartColumn8" class="flow_data_big"></div>
				<div class="eltable_box_yf">
					<div class="table_title_yf"><span>序号</span><span>货主</span><span>货物量(吨)</span></div>
					<ul>
						<li v-for="(item,index) in customname_car_number">
							<span>{{index+1}}</span>
							<el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
								<span>{{item.name.substring(0,5)}}</span>
							</el-tooltip>
							<span>{{item.value/1000}}</span>
						</li>
					</ul>
				</div>

			</div>

		</div>
		<div v-show="amplification3" class="amplification_box">
			<div class="table_box_yf table_box_yf2">
				<img src="@/assets/imgs/screen/data_box_area.png" alt="" class="list_member">
				<img src="@/assets/imgs/screen/icon_close.png" alt="" class="icon_close" @click="un_amplification()">
				<h3 class="title_yf1">车队运输统计（车次）</h3>
				<div ref="chartColumn9" class="flow_data_big3"></div>
			</div>

		</div>
	</div>
</template>

<script>
	import * as echarts from "echarts"
	import axios from "axios";
	const industryColor = {
		type: 'linear',
		x: 1,
		y: 0,
		x2: 1,
		y2: 1,
		colorStops: [{
				offset: 0,
				color: '#6CB5EB'
			},
			{
				offset: 1,
				color: 'rgba(9,36,83,0.27)'
			}
		]
	};

	const industryData = [];

	export default {
		data() {
			return {
				zykhsgsj: 'month',
				hyqydb: 'month',
				zykhsgsj_year: new Date().getFullYear(),
				hyqydb_year: new Date().getFullYear(),
				flowtendata: [],
				flowtendata: [],
				valuelist1tendata: [],
				valuelist2tendata: [],
				flowfivedata: [],
				valuelist1fivedata: [],
				valuelist2fivedata: [],
				chartColumn1: null,
				chartColumn2: null,
				chartColumn3: null,
				chartColumn4: null,
				chartColumn5: null,
				chartColumn6: null,
				chartColumn7: null,
				chartColumn8: null,
				amplification1: false,
				amplification2: false,
				amplification3: false,
				industryData: industryData,
				option5Data: [],
				customname_car_number: [],
				cargoname_car_number: [],
				area: '',
				custom: '',
				option1: {
					title: {
						// text: "单位:车次",
						textStyle: {
							color: '#fff',
							fontStyle: 'normal', //'italic'(倾斜) | 'oblique'(倾斜体) ，字体风格
							fontWeight: 'normal', //'bold'(粗体) | 'bolder'(粗体) | 'lighter'(正常粗细) ，字体粗细
							fontFamily: 'sans-serif', //'sans-serif' | 'serif' | 'monospace' | 'Arial' | 'Courier New' 
							// 'Microsoft YaHei'(微软雅黑) ，文字字体
							fontSize: 12, //字体大小
							lineHeight: 18, //字体行高

						},
						left: 38,
						top: 20,
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						selectedMode: false,
						icon: 'circle',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff'
						},
						right: '5%',
						y: "20",
						labelFormatter: function() {
							return this.name;
						}
					},


					toolbox: {
						show: false,
					},
					calculable: true,
					xAxis: [{
						type: 'category',
						axisTick: {
							show: false
						},
						axisLabel: { //x轴文字的配置
							show: true,
							textStyle: {
								color: "#fff",
							},
							interval: 0, // 坐标轴刻度标签的显示间隔
							rotate: 0 // 标签倾斜的角度
						},
						axisLine: {
							show: true, // 原来x轴的默认横线取消掉，重新设置
							lineStyle: {
								color: 'rgba(28, 246, 210, 0.5)',
							},

						},
						splitLine: {
							show: false
						},
						data: []
					}],
					yAxis: [{
						type: 'value',
						splitLine: {
							show: false
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#ffffff'
							},
						}
					}, ],
					series: [{
							name: '本年初-至今',
							type: 'bar',
							color: "#",
							barWidth: "20",
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#347ff5'
									},
									{
										offset: 0.8,
										color: 'rgba(52,124,216,0.1)'
									},
									{
										offset: 1,
										color: 'rgba(52,124,216,0.1)'
									}
								])
							},
							data: [

							],


						},
						{
							name: '上年度同期',
							type: 'bar',
							barWidth: "20",
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#109faf'
									},
									{
										offset: 0.8,
										color: 'rgba(16,159,175,0.1)'
									},
									{
										offset: 1,
										color: 'rgba(16,159,175,0.1)'
									}
								])
							},
							data: [

							],

						}
					]
				},
				option2: {
					title: {
						// text: "单位:车次",
						textStyle: {
							color: '#fff',
							fontStyle: 'normal', //'italic'(倾斜) | 'oblique'(倾斜体) ，字体风格
							fontWeight: 'normal', //'bold'(粗体) | 'bolder'(粗体) | 'lighter'(正常粗细) ，字体粗细
							fontFamily: 'sans-serif', //'sans-serif' | 'serif' | 'monospace' | 'Arial' | 'Courier New' 
							// 'Microsoft YaHei'(微软雅黑) ，文字字体
							fontSize: 12, //字体大小
							lineHeight: 18, //字体行高

						},
						left: 38,
						top: 20,
					},
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',
						data: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
						axisLabel: {
							color: '#E6F7FF'
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: 'rgba(255, 255, 2555, 0.1)'
							}
						},
						axisTick: {
							show: false
						},
						animation: false
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							color: '#E6F7FF'
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: 'rgba(255,255,255,0.2)'
							}
						},
						animation: false
					},
					series: [{
							name: '车辆运输统计（车次）',
							type: 'bar',
							barWidth: 9,
							data: industryData,
							itemStyle: {
								//柱子左面
								normal: {
									// 重要的是color配置：线性渐变， 从上往下
									color: {
										type: 'linear',
										x: 1,
										y: 0,
										x2: 1,
										y2: 1,
										colorStops: [{
												offset: 0,
												color: '#6CB5EB'
											},
											{
												offset: 0.8,
												color: 'rgba(9, 36, 83, 0.54)'
											}
										]
									}
								}
							},
							tooltip: {
								show: false
							}
						},
						{
							name: '车辆运输统计（车次）',
							tooltip: {
								show: true,
								padding: 100,
								position: [-10, '50%'],
								borderWidth: 100
							},
							type: 'bar',
							barWidth: 13,
							barCategoryGap: '60%',
							itemStyle: {
								//柱子右面
								normal: {
									// 重要的是color配置：线性渐变， 从上往下
									color: industryColor,
									borderWidth: 0.3,
									borderColor: 'rgba(9, 36, 83, 0.1)'
								}
							},
							data: industryData,
							// 间隔为0
							barGap: 0,
							z: 5
						},
						{
							z: 10,
							name: '车辆运输统计（车次）',
							type: 'pictorialBar',
							symbolPosition: 'end',
							data: industryData,
							symbol: 'diamond',
							symbolOffset: [0, -10],
							symbolRotate: 90,
							symbolSize: [3.5, 19.6],
							itemStyle: {
								normal: {
									borderWidth: 0,
									color: 'rgba(124, 201, 250, 1)'
								}
							},
							tooltip: {
								show: false
							}
						}
					]
				},
				option3: {
					title: {
						// text: "单位:万吨",
						textStyle: {
							color: '#fff',
							fontStyle: 'normal', //'italic'(倾斜) | 'oblique'(倾斜体) ，字体风格
							fontWeight: 'normal', //'bold'(粗体) | 'bolder'(粗体) | 'lighter'(正常粗细) ，字体粗细
							fontFamily: 'sans-serif', //'sans-serif' | 'serif' | 'monospace' | 'Arial' | 'Courier New' 
							fontSize: 12, //字体大小
							lineHeight: 18, //字体行高

						},
						left: 48,
						top: 20,
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						selectedMode: false,
						icon: 'circle',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff'
						},
						right: '10%',
						y: "20",
						labelFormatter: function() {
							return this.name;
						}
					},


					toolbox: {
						show: false,
					},
					calculable: true,
					xAxis: [{
						type: 'category',
						axisTick: {
							show: false
						},
						axisLine: {
							show: false, // 原来x轴的默认横线取消掉，重新设置
							lineStyle: {
								color: 'rgba(255,255,255,0.3)'
							},
						},
						data: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
					}],
					yAxis: [{
						type: 'value',
						splitLine: {
							show: true, // 原来x轴的默认横线取消掉，重新设置
							lineStyle: {
								color: 'rgba(255,255,255,0.3)'
							},
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#ffffff'
							},
						}
					}, ],
					series: [{
							name: '出库',
							type: 'line',
							symbol: "none",
							itemStyle: {
								color: '#3E8CF5'
							},
							data: [

							],


						},
						{
							name: '入库',
							type: 'line',
							symbol: "none",
							itemStyle: {
								color: '#1CF6D2'
							},
							data: [

							],

						}
					]
				},
				option4: {
					tooltip: {
						// show: false // 弹层数据去掉
					},
					title: {
						text: ''
					},
					legend: {
						selectedMode: false,
						icon: 'circle',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff'
						},
						right: '10%',
						y: "20",
						labelFormatter: function() {
							return this.name;
						}
					},
					radar: {
						splitNumber: 7, // 雷达图圈数设置
						splitLine: {
							show: false,
						},
						axisLine: {
							show: false,
						},
						splitArea: {
							show: true,
							color: ['rgba(255,255,255,0.6)', 'rgba(255,255,255,0.5)', 'rgba(255,255,255,0.4)',
								'rgba(255,255,255,0.3)', 'rgba(255,255,255,0.2)', 'rgba(255,255,255,0.1)',
								'rgba(255,255,255,0.05)'
							],

						},
						indicator: [

						],
						triggerEvent: true
					},
					series: [{
						name: '',
						type: 'radar',
						data: [{
								value: [],
								name: '本年',
								// itemStyle: {
								//  normal: {
								//   color: '#fff'
								//  }
								// },
								lineStyle: {
									color: "rgba(62, 177, 252, 1)",
								},
								areaStyle: {
									color: 'rgba(62, 177, 252, 0.5)'
								}
							},
							{
								value: [],
								name: '上年',
								// itemStyle: {
								//  normal: {
								//   color: '#fff'
								//  }
								// },
								lineStyle: {
									color: "rgba(26, 213, 139, 1)",
								},
								areaStyle: {
									color: 'rgba(26, 213, 139, 0.5)'
								}
							}
						]
					}]
				},
				option5: {
					title: {},
					legend: {
						left: '20',
						top: '90',
						icon: "circle", //设置图例图标的形状为实心圆，这个不填，默认是矩形
						width: "100",
						textStyle: {
							fontSize: 12, //图例文字字体大小
							color: '#ffff' //图例文字颜色
						}

					},
					tooltip: {
						show: true
					},
					series: [{
						name: 'Radius Mode',
						type: 'pie',
						radius: [20, 120],
						center: ['55%', '46%'],
						roseType: 'radius',
						itemStyle: {
							borderRadius: 5
						},
						label: {
							show: false
						},
						emphasis: {
							label: {
								show: false
							}
						},
						data: [],
					}, ]
				},
				option6: {
					grid: {
						left: "3%",
						right:"5%",
						containLabel: true
					},

					title: {
						// text: "单位:车次",
						textStyle: {
							color: '#fff',
							fontStyle: 'normal', //'italic'(倾斜) | 'oblique'(倾斜体) ，字体风格
							fontWeight: 'normal', //'bold'(粗体) | 'bolder'(粗体) | 'lighter'(正常粗细) ，字体粗细
							fontFamily: 'sans-serif', //'sans-serif' | 'serif' | 'monospace' | 'Arial' | 'Courier New' 
							// 'Microsoft YaHei'(微软雅黑) ，文字字体
							fontSize: 12, //字体大小
							lineHeight: 18, //字体行高

						},
						left: '0',
						top: 30,
					},
					tooltip: {
						trigger: 'axis'
					},

					

					toolbox: {
						show: false,
					},
					calculable: true,
					yAxis: [{
						type: 'category',
						axisTick: {
							show: false
						},
						
						axisLine: {
							show: false, // 原来x轴的默认横线取消掉，重新设置
							lineStyle: {
								color: '#ffffff'
							},
							
						},
						splitLine: {
							show: false
						},
						data: [],
						axisLabel: {
						interval: 0,
						
						formatter: function(value) {
							if (value.length > 5) {
									return value.substring(0, 4) + "...";
								} else {
									return value;
								}
							}
						},
					}],
					xAxis: [{
							type: 'value',
							splitLine: {
								show: false
							},
							axisLine: {
								show: false,
								lineStyle: {
									color: '#ffffff'
								},
							},
							axisLabel: {
								interval: 5,
								formatter: function(value, index) {
									// value大于1000时除以1000并拼接k，小于1000按原格式显示
									if (value >= 1000) {
										value = value / 1000 + "k";
									} else if (value < 1000) {
										value;
									}
									return value;
								}
							}
						},

					],
					series: [{
							name: '',
							type: 'bar',
							color: "#",
							barWidth: "10",
							itemStyle: {
								color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
										offset: 0,
										color: '#347ff5'
									},
									{
										offset: 0.8,
										color: 'rgba(52,124,216,0.1)'
									},
									{
										offset: 1,
										color: 'rgba(52,124,216,0.1)'
									}
								])
							},
							data: [

							],


						},

					]
				},
			}
		},
		computed: {

		},
		watch: {

		},
		created() {

		},
		mounted() {

			// this.initChart()
			this.getarea_car_number()
			this.getarea_car_number2()
		},
		beforeDestroy() {

		},
		components: {

		},

		methods: {

			changeYearMonth(type) {
				
				const now = new Date();
				const year = now.getFullYear();
				
				if (type == 1) {
					if (this.zykhsgsj_year == year) {
						this.zykhsgsj_year = year-1;
					} else {
						this.zykhsgsj_year = year;
					}
					console.log('zykhsgsj_year',this.zykhsgsj_year)
					this.getCustomer();

				} else {
					if (this.hyqydb_year == year) {
						this.hyqydb_year = year-1;
					} else {
						this.hyqydb_year = year;
					}
					this.getHuoYunQiYun();
				}
			},

			getarea_car_number() {
				var year = new Date().getFullYear();
				var years_old = parseInt(year) - 1;
				axios({
					method: 'get',
					url: `${this.$bigScreenApiBase}big/screen/selectBigScreenStnameCount `,
					headers:{
						token:JSON.parse(decodeURIComponent(window.sessionStorage.getItem("user"))).token
					}
				}).then(
					(res) => {
						// var area_car_number = res.data.data;
						var namelist = [];
						var valuelist = [];
						var max = 0;
						
						// this.option4.series[0].data[0].value = valuelist
						// axios({
						// 	method: 'get',
						// 	url: `${this.$bigScreenApiBase}/dv/area_car_number?years=` + years_old,
						// }).then(
						// 	(res) => {
						// 		var area_car_number1 = res.data.data;
								var valuelist1 = [];
						// 		for (var i = 0; i < area_car_number1.length; i++) {
						// 			valuelist1.push(area_car_number1[i].val);
						// 			if (max < parseInt(area_car_number1[i].val)) {
						// 				max = parseInt(area_car_number1[i].val)
						// 			}
						// 		}
						// 		for (var i = 0; i < namelist.length; i++) {
						// 			namelist[i].max = parseInt(max * 1.2)
						// 		}
						// 		this.option4.series[0].data[1].value = valuelist1
						// 		this.option4.radar.indicator = namelist
						// 		this.chartColumn4 = echarts.init(this.$refs.chartColumn4);
						// 		this.chartColumn4.setOption(this.option4);
						// 		console.log(this.option4);
						// 		// this.chartColumn4.off('click');
						// 		var that = this;
						// 		that.chartColumn4.off('click');
						// 		that.chartColumn4.on('click', function(params) {
						// 			if (params.targetType == "axisName") {
						// 				that.area = params.name;
						// 				that.custom = '';
						// 				that.getarea_car_number2();
						// 			}
						// 		});
						// 	},
						// 	(err) => {

						// 	},
						// )	
						res.data.data.forEach(item => {
							if(max < parseInt(item.thisYearCarCount)){
								max = parseInt(item.thisYearCarCount)
							}
							namelist.push({
								"name": item.name,
								'max': parseInt(item.thisYearCarCount) * 1.1
							});
							if (max < parseInt(item.lastYearCarCount)) {
									max = parseInt(item.lastYearCarCount)
								}
							for (var i = 0; i < namelist.length; i++) {
								namelist[i].max = parseInt(max * 1.2)
							}
							valuelist.push(item.thisYearCarCount)
							valuelist1.push(item.lastYearCarCount)
						});	
						this.option4.series[0].data[0].value = valuelist
						this.option4.series[0].data[1].value = valuelist1
						this.option4.radar.indicator = namelist
						this.chartColumn4 = echarts.init(this.$refs.chartColumn4);
						this.chartColumn4.setOption(this.option4);
					},
					(err) => {
						console.log(err);
					},
				)


				this.getHuoYunQiYun();
			},
			getarea_car_number2() {

				axios({
					method: 'get',
					url: `${this.$bigScreenApiBase}big/screen/bigScreenFleetTransportCount` 
				}).then(
					(res) => {
						var custmername = res.data.data;
						var valuelist1 = [];
						var valuelist2 = [];
						var data = [];
						// custmername["今年"].sort((a, b) => {
						// 	if (parseInt(a.val) < parseInt(b.val)) {
						// 		return 1; // a排在b之前
						// 	} else if (parseInt(a.val) > parseInt(b.val)) {
						// 		return -1; // a排在b之后
						// 	}
						// 	return 0; // a和b位置不变
						// });
						for (var i = 0; i < custmername.length; i++) {
							var name = custmername[i].name;
							valuelist1.push(custmername[i].thisYearCarCount);
							data.push(name);
							valuelist2.push(custmername[i].lastYearCarCount);
						}

						this.flowtendata = data.slice(0, 10);
						this.valuelist1tendata = valuelist1.slice(0, 10);
						this.valuelist2tendata = valuelist2.slice(0, 10);
						this.flowfivedata = data.slice(0, 5);
						this.valuelist1fivedata = valuelist1.slice(0, 5);
						this.valuelist2fivedata = valuelist2.slice(0, 5);
						this.option1.xAxis[0].data = this.flowfivedata
						this.option1.series[0].data = this.valuelist1fivedata
						this.option1.series[1].data = this.valuelist2fivedata
						this.chartColumn1 = echarts.init(this.$refs.chartColumn1);

						this.chartColumn1.setOption(this.option1);
						var that = this;
						that.chartColumn1.off('click');
						that.chartColumn1.on('click', function(params) {
							that.custom = params.name;
							// that.getCustomer(params.name);
							that.getCustomerAndHuoYun();
							// if(params.targetType=="axisName"){
							// 	that.area =  params.name;
							// 	that.getarea_car_number2();
							// }
						});
					},
					(err) => {

					},
				)

				axios({
					method: 'get',
					url: `${this.$bigScreenApiBase}big/screen/bigScreenCargoStatistics` 
				}).then(
					(res) => {
						this.cargoname_car_number = res.data.data
						var cargoname_car_number = res.data.data
						for (var i = 0; i < cargoname_car_number.length; i++) {
							cargoname_car_number[i].value = cargoname_car_number[i].value/1000;
						}
						this.option5.series[0].data = cargoname_car_number.slice(0, 8)
						this.option5.series[0].name = "";
						this.chartColumn5 = echarts.init(this.$refs.chartColumn5);
						this.chartColumn5.setOption(this.option5);
					},
					(err) => {

					},
				)
				axios({
					method: 'get',
					url: `${this.$bigScreenApiBase}big/screen/bigScreenHostRankingStatistics`
				}).then(
					(res) => {
						this.customname_car_number = res.data.data;
						var customname = res.data.data;
						var valuelist1 = [];
						var data = [];
						for (var i = 0; i < customname.length; i++) {
							valuelist1.push(customname[i].value/1000);
							data.push(customname[i].name);
						}
						this.option6.yAxis[0].data = data.slice(0, 5).reverse()
						this.option6.series[0].data = valuelist1.slice(0, 5).reverse()

						this.chartColumn6 = echarts.init(this.$refs.chartColumn6);
						this.chartColumn6.setOption(this.option6);
					},
					(err) => {

					},
				)

				this.getCustomerAndHuoYun();
			},




			getCustomerAndHuoYun() {

				this.getHuoYunQiYun();
				this.getCustomer();

			},

			getCustomer() {
				var dtype = 'year';
				if (this.zykhsgsj == 'month') {
					dtype = 'month';
				}

				axios({
					method: 'get',
					url: `${this.$bigScreenApiBase}big/screen/bigScreenCarYearTransportCount?year=`+this.zykhsgsj_year+`&shortname=` + this.custom 
				}).then(
					(res) => {
						var custom_car_number = res.data.data;
						var valuelist = [];
						var data = [];
						for (var i = 0; i < custom_car_number.length; i++) {
							valuelist.push(parseInt(custom_car_number[i].value));
							data.push(custom_car_number[i].name);
						}
						// this.option2.xAxis.data = data;

						if (this.zykhsgsj == 'month') {
							this.option2.xAxis.data = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10",
								"11", "12"
							];
						} else {
							this.option2.xAxis.data = [];
							let year = new Date().getFullYear();
							for (let index = 9; index >= 0; index--) {
								this.option2.xAxis.data.push(year - index);
							}
						}

						this.option2.series[0].data = valuelist;
						this.option2.series[1].data = valuelist;
						this.option2.series[2].data = valuelist;
						this.chartColumn2 = echarts.init(this.$refs.chartColumn2);
						this.chartColumn2.setOption(this.option2);
					},
					(err) => {

					},
				)
			},
			getHuoYunQiYun() {
				var dtype = 'year';
				if (this.zykhsgsj == 'month') {
					dtype = 'month';
				}
				axios({
					method: 'get',
					url: `${this.$bigScreenApiBase}big/screen/rareSetCarCount?year=`+this.hyqydb_year+`&shortname=` + this.custom,

				}).then(
					(res) => {
						if (this.hyqydb == 'month') {
							this.option3.xAxis[0].data = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10",
								"11", "12"
							];
						} else {
							this.option3.xAxis[0].data = [];
							let year = new Date().getFullYear();
							for (let index = 9; index >= 0; index--) {
								this.option3.xAxis[0].data.push(year - index);
							}
						}
						this.option3.series[0].data = []
						this.option3.series[1].data = []
						res.data.data.forEach(item=>{
							this.option3.series[0].data.push(item.timeCount[0].value)
							this.option3.series[1].data.push(item.timeCount[1].value)
						})
						// this.option3.series[0].data = res.data.data[0];
						// this.option3.series[1].data = res.data.data[1];
						this.chartColumn3 = echarts.init(this.$refs.chartColumn3);
						this.chartColumn3.setOption(this.option3);
					},
					(err) => {
						console.log(err);
					},
				)
			},


			amplification(index) {
				if (index == 1) {
					this.amplification1 = true;
					this.chartColumn7 = echarts.init(this.$refs.chartColumn7);
					this.option5.legend = {
						left: '100',
						top: "50",
						icon: "circle", //设置图例图标的形状为实心圆，这个不填，默认是矩形
						width: "100",
						textStyle: {
							fontSize: 20, //图例文字字体大小
							lineHeight: 30,
							color: '#ffff' //图例文字颜色
						}


					};
					this.option5.series[0].radius = '100%';
					this.option5.series[0].center = ['65%', '50%'];
					this.chartColumn7.setOption(this.option5);

				}
				if (index == 2) {
					this.amplification2 = true;
					this.option6.title = {
						// text: "单位:车次",
						textStyle: {
							color: '#fff',
							fontStyle: 'normal', //'italic'(倾斜) | 'oblique'(倾斜体) ，字体风格
							fontWeight: 'normal', //'bold'(粗体) | 'bolder'(粗体) | 'lighter'(正常粗细) ，字体粗细
							fontFamily: 'sans-serif', //'sans-serif' | 'serif' | 'monospace' | 'Arial' | 'Courier New' 
							// 'Microsoft YaHei'(微软雅黑) ，文字字体
							fontSize: 24, //字体大小
							lineHeight: 36, //字体行高

						},
						left: '0',
						top: 30,
					};
					this.option6.yAxis[0].axisLabel = {
						textStyle: {
							fontSize: 20,

						},
						formatter: function(value) {
							if (value.length > 5) {
									return value.substring(0, 4) + "...";
								} else {
									return value;
								}
							}
					};
					this.option6.xAxis[0].axisLabel = {
						interval: 5,
						textStyle: {
							fontSize: 20
						},
						formatter: function(value, index) {
							// value大于1000时除以1000并拼接k，小于1000按原格式显示
							if (value >= 1000) {
								value = value / 1000 + "k";
							} else if (value < 1000) {
								value;
							}
							return value;
						}
					}

					this.chartColumn8 = echarts.init(this.$refs.chartColumn8);
					this.chartColumn8.setOption(this.option6);
				}

				if (index == 3) {
					this.amplification3 = true;
					this.chartColumn9 = echarts.init(this.$refs.chartColumn9);
					this.option1.legend = {
						selectedMode: false,
						icon: 'circle',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff'
						},
						right: '10%',
						y: "20",
						labelFormatter: function() {
							return this.name;
						}
					};
					this.option1.xAxis[0].data = this.flowtendata
					this.option1.series[0].data = this.valuelist1tendata
					this.option1.series[1].data = this.valuelist2tendata
					this.chartColumn9.setOption(this.option1);
				}

			},
			un_amplification() {
				this.amplification1 = false;
				this.amplification2 = false;
				this.amplification3 = false;
				this.option5.legend = {
					left: '20',
					top: '90',
					icon: "circle", //设置图例图标的形状为实心圆，这个不填，默认是矩形
					width: "100",
					textStyle: {
						fontSize: 12, //图例文字字体大小
						color: '#ffff' //图例文字颜色
					}

				};
				this.option6.title = {
					text: "单位:车次",
					textStyle: {
						color: '#fff',
						fontStyle: 'normal', //'italic'(倾斜) | 'oblique'(倾斜体) ，字体风格
						fontWeight: 'normal', //'bold'(粗体) | 'bolder'(粗体) | 'lighter'(正常粗细) ，字体粗细
						fontFamily: 'sans-serif', //'sans-serif' | 'serif' | 'monospace' | 'Arial' | 'Courier New' 
						// 'Microsoft YaHei'(微软雅黑) ，文字字体
						fontSize: 12, //字体大小
						lineHeight: 18, //字体行高

					},
					left: '0',
					top: 30,
				};
			},
			initChart() {
				this.chartColumn3 = echarts.init(this.$refs.chartColumn3);
				this.chartColumn3.setOption(this.option3);

			}
		}
	};
</script>

<style lang="scss" scoped>
	#root {
		overflow: hidden;
	}

	.container_yf {
		width: 1920px;
		height: 1080px;
	}

	.left_box_yf {
		position: absolute;
		left: 28px;
		top: 100px;
		width: 48%;
		.list_member_box {
			display: flex;
			justify-content: space-between;
			width: 100%;
			.table_box_yf{
				width: 49%;
			}
		}

		.list_member1,.list_member {
			width: 100%;
			height: 339px;
		}
	}

	.right_box_yf {
		position: absolute;
		right: 28px;
		top: 100px;
		width: 48%;
	}

	.table_box_yf {
		position: relative;
		margin-bottom: 22px;

		h3 {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #FFFFFF;
			width: 100%;
			position: absolute;
			left: -4px;
			text-align: center;
			top: 16px;

			&.title_yf1 {
				left: 6px;
			}

			&.title_yf2 {
				left: -10px;
			}

			&.title_yf3 {
				top: 20px;
			}
		}

		.icon_expand {
			position: absolute;
			right: 18px;
			top: 18px;
			z-index: 99;
			animation: scale1 2s linear 0s infinite normal;
			cursor: pointer;
		}

		.icon_close {
			position: absolute;
			right: 30px;
			top: 30px;
			z-index: 99;
		}
	}

	@keyframes scale1 {
		0% {
			transform: scale(1);

		}

		50% {
			transform: scale(0.8);

		}

		100% {
			transform: scale(1);
		}
	}

	.data_box_train1 {
		height: 280px;
		width: 935px;
	}

	.data_box_train0 {
		height: 590px;
		width: 100%;
	}

	.flow_data {
		position: absolute;
		height: 260px;
		width: 100%;
		left: -10px;
		top: 60px
	}

	.flow_data1 {
		position: absolute;
		height: 480px;
		width: 90%;
		left: 50px;
		top: 100px
	}

	.flow_data2 {
		position: absolute;
		height: 400px;
		width: 90%;
		left: 0px;
		top: 10px
	}

	.flow_data3 {
		position: absolute;
		height: 300px;
		width: 90%;
		left: 20px;
		top: 50px
	}

	.flow_data5 {
		position: absolute;
		height: 200px;
		width: 800px;
		left: 70px;
		top: 70px
	}

	.amplification_box {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.9);
		z-index: 9999;

		.table_box_yf2 {
			width: 1265px;
			height: 755px;
			position: absolute;
			left: 0;
			top: 0;
			right: 0;
			bottom: 0;
			margin: auto;

			h3 {
				font-size: 22px;
				top: 30px
			}

			.flow_data_big {
				width: 700px;
				height: 500px;
				top: 150px;
				position: absolute;
				left: 50px;
			}

			.flow_data_big2 {
				top: 180px;
				left: 0;
			}

			.flow_data_big3 {
				width: 1400px;
				height: 500px;
				top: 150px;
				position: absolute;
				margin-right: 20px;
			}

			.eltable_box_yf {
				position: absolute;
				right: 90px;
				top: 223px;

				ul {
					height: 354px;
					overflow-y: auto;

					&::-webkit-scrollbar {
						width: 2px;
						/*高宽分别对应横竖滚动条的尺寸*/
						height: 1px;
					}

					&::-webkit-scrollbar-thumb {
						/*滚动条里面小方块*/
						border-radius: 3px;
						background: #1CF6D2;
						box-shadow: none;
					}

					//滚动条底层颜色!
					&::-webkit-scrollbar-track {
						border-radius: 3px;
						background: rgba(0, 0, 0, .1);
						box-shadow: none;
					}

				}

				.table_title_yf {
					color: #fff;
					display: flex;
					text-align: center;
					background: rgba(34, 178, 233, 0.5);
					border-radius: 10px 10px 0px 0px;

					span {
						display: block;
						width: 152px;
						font-size: 18px;
						line-height: 36px;
						height: 36px;
						margin-left: -1px;
						background: rgba(52, 124, 216, 0.3);
						margin-top: -1px;

						&:first-child {
							width: 82px;
						}
					}

					span {
						border: none;
						background: none;
					}
				}

				li {
					color: #fff;
					display: flex;
					text-align: center;
					background: rgba(19, 56, 135, 0.3);

					span {
						display: block;
						width: 152px;
						font-size: 18px;
						line-height: 36px;
						height: 36px;
						margin-left: -1px;
						background: rgba(52, 124, 216, 0.3);
						margin-top: -1px;

						&:first-child {
							width: 82px;
						}
					}

					// &:first-child {}

					&:nth-child(2n) {
						background: rgba(8, 16, 55, 0.3);
					}
				}
			}
		}
	}
</style>